import * as TYPES from './constants';
import { LANG_NAME } from 'CONSTANTS';

const translations = {
  en: () => import('translations/en'),
  pl: () => import('translations/pl'),
}

export const openModal = (id:number | string, extra: any) => dispatch => {
  dispatch({ type: TYPES.MODAL_OPEN, id, extra, close: () => dispatch({ type: TYPES.MODAL_CLOSE }) });
  return Promise.resolve();
}

export const closeModal = () => dispatch => {
  dispatch({ type: TYPES.MODAL_CLOSE });
  return Promise.resolve();
}

export const initLanguageWorker = () => async (dispatch, getState) => {
  let lang = getState().ui.language;
  dispatch(changeLanguageWorker(lang));  
}

export const changeLanguageWorker = (language) => async (dispatch) => {
  let lang = language;
  if(!translations[lang]) {
    lang = 'en';
  }
  try {
    const translation = await translations[lang]();
    dispatch({ type: TYPES.CHANGE_LANGUAGE, language: lang, translation: translation.default });
    document.documentElement.setAttribute('lang', lang);
    localStorage.setItem(LANG_NAME, language); // setting language, not lang!
  } catch(err) {
    console.error('loading translation error', err);
  }
}


// WEBPACK FOOTER //
// ./src/ducks/ui/actions.js